import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";

import useRouteOfAdministration from "./hooks/useRouteOfAdministration";

const RouteOfAdministration = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const routeOfAdministrationData = useRouteOfAdministration(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={routeOfAdministrationData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {routeOfAdministrationData.screen_title} -{" "}
          <span className="heading-cod">
            {routeOfAdministrationData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={routeOfAdministrationData.formFields}
        dropdownValues={routeOfAdministrationData.dropdownValues}
        paramsData={routeOfAdministrationData.paramsData}
        updataParamData={routeOfAdministrationData.updateParamData}
      />
      <ButtonsSection ctaButtons={routeOfAdministrationData.ctaButtons} />
      <DisplayTable
        data={routeOfAdministrationData.data}
        parmKey={routeOfAdministrationData.parmKey}
        menuOptions={routeOfAdministrationData.menuOptions}
        tableHeaders={routeOfAdministrationData.columnDef}
        setRowData={routeOfAdministrationData.setRowData}
        selectedPriceSchedules={routeOfAdministrationData.selectedRows}
        setSelectedPriceSchedules={routeOfAdministrationData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={routeOfAdministrationData.first}
          rows={routeOfAdministrationData.rows}
          totalRecords={routeOfAdministrationData.totalRecords}
          currentPage={routeOfAdministrationData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={routeOfAdministrationData.onPageChange}
        />
      </div>
      {routeOfAdministrationData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={routeOfAdministrationData.isConfirmationModalOpen}
          onRequestClose={routeOfAdministrationData.closeConfirmationModal}
          onBack={routeOfAdministrationData.closeConfirmationModal}
          onSave={routeOfAdministrationData.deleteRouteOfAdministration}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={routeOfAdministrationData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default RouteOfAdministration;
